import { nanoid } from 'nanoid';
import { runtime } from '../../runtime/Runtime';
export class EntityInfo {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get entity() {
        return this.parent;
    }
    get objectId() {
        if (!this.objectIdVar) {
            this.objectIdVar = nanoid(6);
        }
        return this.objectIdVar;
    }
    set objectId(v) {
        this.objectIdVar = v;
    }
    objectIdVar;
    get isActor() {
        return this.entity instanceof runtime.class.Actor;
    }
}
